module.exports = {
  
  siteTitle: `CJ Coder`, // <title>
  manifestName: `Cj Coder`,
  manifestShortName: 'Cj Coder', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#b22222',
  manifestThemeColor: '#22b2b2',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/images/lohith.jpg',
  // pathPrefix: `/imlohith/`, // This path is subpath of your hosting https://domain/portfolio
  heading: `I'm lohith`,
  subHeading: 'Full stack web developer @Actvia Innovations. ',

  // social
  socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      url: 'https://github.com/imlohith',
    },
    {
      icon: 'fa-linkedin-in',
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/lohith-kumar-39b723b3/',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: '#',
    },
    {
      icon: 'fa-facebook-f',
      name: 'Facebook',
      url: '#',
    },
  ],
  email: 'Lohithkumar.g@activa.one',
  phone: '+91 8686351929',
  address: 'The platina building, Gachibowli- Hyderabad',
};
